import { useSnackbar } from "notistack";
import { FC, ReactNode, useEffect } from "react";

import { DEFAULT_COSMOS_CHAIN_ID } from "../config";
import { cosmosConnectorsMap } from "../connectors";
import { useWeb3Connectors } from "./Web3ConnectorsProvider";

export const Web3Setup: FC<{ children: ReactNode }> = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { connectorsMap } = useWeb3Connectors();

  const connectEagerly = (lastEvmConnector: string | null) => {
    if (lastEvmConnector) {
      connectorsMap[lastEvmConnector].connectEagerly().catch(() => {
        localStorage.removeItem("lastEvmConnector"); // failed to connectEagerly - do not try again
      });
    }

    const lastCosmosConnector = localStorage.getItem("lastCosmosConnector");
    if (lastCosmosConnector) {
      cosmosConnectorsMap[lastCosmosConnector]
        .connectEagerly(DEFAULT_COSMOS_CHAIN_ID)
        .catch(() => {
          localStorage.removeItem("lastCosmosConnector"); // failed to connectEagerly - do not try again
        });
    }
  };

  useEffect(() => {
    const lastEvmConnector = localStorage.getItem("lastEvmConnector");

    if (lastEvmConnector === "xdefi") {
      const xdefiInterval = setInterval(() => {
        if (!connectorsMap[lastEvmConnector]) {
          return;
        }

        connectEagerly(lastEvmConnector);
        clearInterval(xdefiInterval);
      }, 500);
      return () => clearInterval(xdefiInterval);
    }

    connectEagerly(lastEvmConnector);

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enqueueSnackbar]);

  return <>{children}</>;
};
